import type {
    GetLeadCardFields_leadCardFields as LeadCardField,
    GetFields_createModalFields as CreateModalField,
} from 'nutshell-graphql-types';

import type {EntityFormType, SelectableField} from './types';

export function getFieldKey(field: any) {
    return field.entityAttributeId || field.name;
}

export const getTitle = (
    fieldName: string,
    title: string,
    entityType: EntityFormType,
    isLeadCard?: boolean
) => {
    if (fieldName === 'email') {
        return 'Email';
    }

    if (fieldName === 'accounts') {
        if (entityType === 'contacts') {
            return 'Company';
        } else if (isLeadCard) {
            return 'Related company';
        }
    }

    if (fieldName === 'contacts') {
        if (entityType === 'accounts') {
            return 'Person';
        } else if (isLeadCard) {
            return 'Related person';
        }
    }

    if (fieldName === 'products' && entityType === 'leads' && NutClientConfig.hasRevenueWidgetFF) {
        return 'Revenue';
    }

    return title;
};

export const mapFieldsToSelectableFields = (
    fields: LeadCardField[] | CreateModalField[]
): SelectableField[] =>
    fields.map((field) => ({
        __typename: 'SelectableField',
        fieldId: field.fieldId,
        isRequired: field.isRequired,
        isRemoveable: field.isRemoveable,
    }));
